import React, { ReactNode } from "react";
import { Box, ButtonBase, Typography, styled } from "@mui/material";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";

const Option = styled(ButtonBase)(({ theme }) => ({
  width: "100%",
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(3),
  padding: theme.spacing(3),
  borderRadius: 12,
  border: `1px solid ${theme.palette.border.secondary}`,
  textAlign: "left",
}));

const IconTile = styled("span")(({ theme }) => ({
  flex: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 40,
  height: 40,
  borderRadius: 8,
  backgroundColor: theme.palette.background.info,
  color: theme.palette.primary.main,
  "& svg": { width: 20, height: 20 },
}));

interface Props {
  icon: ReactNode;
  title: string;
  description: string;
  onClick: () => void;
  testId: string;
}

export const AddChoiceOption = ({
  icon,
  title,
  description,
  onClick,
  testId,
}: Props) => (
  <Option onClick={onClick} data-testid={testId}>
    <IconTile aria-hidden>{icon}</IconTile>
    <Box flex={1} minWidth={0}>
      <Typography variant="body4" component="div" color="textPrimary">
        {title}
      </Typography>
      <Typography variant="caption" component="div" color="textSecondary">
        {description}
      </Typography>
    </Box>
    <ChevronRightRoundedIcon
      aria-hidden
      sx={{ flex: "none", color: "icon.secondary" }}
    />
  </Option>
);
